<template>
  <form class="sign-in-confirm-updating-phone" @submit.prevent="handlerSubmit">
    <ModalTitle>{{ messages.updatePhoneTitle }}</ModalTitle>
    <p class="sign-in-confirm-updating-phone__text">
      {{ messages.weSentSmsOnNumber }} {{ getPhoneNumber }}
    </p>
    <!--go back to sign in-->
    <div v-if="timer > 0" class="sign-in-confirm-updating-phone__text">
      {{ messages.changePhoneCanAfter }}
      <span class="sign-in-confirm-updating-phone__timer">{{ timer }} {{ messages.sec }}</span>
    </div>
    <DefLink v-else class="sign-in-confirm-updating-phone__mistake" @click="handlerMistake">
      {{ messages.wrongNumber }}
    </DefLink>

    <DefInput
      name="code"
      type="number"
      :placeholder="messages.codeFromSms"
      :is-show-error="Boolean(errorConfirmPhone)"
      :required="true"
      :value="''"
    >
      {{ errorConfirmPhone }}
    </DefInput>
    <div class="sign-in-confirm-updating-phone__text">{{ messages.didntGetCode }}</div>
    <div v-if="timer > 0" class="sign-in-confirm-updating-phone__text">
      {{ messages.sendAgainAfter }}
      <span class="sign-in-confirm-updating-phone__timer">{{ timer }} {{ messages.sec }}</span>
    </div>
    <!-- resend message -->
    <DefLink v-else @click="handlerResend">
      {{ messages.sendAgain }}
    </DefLink>
    <!-- sign in -->
    <DefButtonPrimary type="submit">
      {{ messages.btnApprove }}
    </DefButtonPrimary>
  </form>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ModalTitle from '@components/modals/Parts/ModalTitle.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import SignInUpdate from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInUpdate.vue';
import SignInSuccessPhoneUpdate from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInSuccessPhoneUpdate.vue';
import Recaptcha3 from '../../../../utils/Recaptcha3';

export default {
  name: 'SignInConfirmUpdatingPhone',
  components: { DefButtonPrimary, DefInput, DefLink, ModalTitle },
  props: ['result', 'messages'],
  data() {
    return {
      timer: 90,
      timeOut: null,
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      user: ({ personal }) => personal.data?.authInfo,
      messages: ({ results }) => results.messages.entry,
      errorConfirmPhone: ({ personal }) => personal.data?.errors?.confirmPhone,
    }),
    getPhoneNumber() {
      return this.result?.phone;
    },
  },
  methods: {
    ...mapMutations({
      clearState: 'personal/clearState',
      setError: 'personal/setError',
    }),
    ...mapActions({
      confirmPhone: 'personal/confirmPhoneForUpdate',
    }),
    async handlerSubmit({ target }) {
      const formData = new FormData(target);
      formData.set('phone', this.result?.phone);
      formData.set('id', this.result?.id);
      const response = await this.confirmPhone(formData);
      if (response.status) {
        this.showSuccessModal(response.text);
      } else {
        this.setError({ confirmPhone: response.text });
      }
    },

    counter() {
      if (this.timer > 0) {
        this.timer -= 1;
        this.timeOut = setTimeout(this.counter, 1000);
      }
    },
    async handlerResend() {
      const token = await Recaptcha3.getSubmitToken();
      let phone = this.result?.phone;
      phone = phone?.replace(/[+| |(|)]/g, '');
      const requestParams = {
        'g-recaptcha-response': token,
        id: this.result?.id,
        phone,
      };
      const response = await this.$store.dispatch('personal/signInDoPhoneUpdate', {
        requestParams,
      });
      if (response.status && response.isCodeWasSend) {
        this.timer = 90;
        this.counter();
      }
    },
    handlerMistake() {
      this.modal.show(
        SignInUpdate,
        {
          response: {
            id: this.user.user_id,
            phone: this.user.userPersonalPhone,
          },
        },
        { width: '340px' }
      );
      // this.$DefModal.show({
      //   name: 'SignInUpdate',
      //   width: '340px',
      //   backgroundClose: () => {
      //     this.setError({ closeModalError: this.messages.closeModalError });
      //   },
      //   isShowClose: false,
      //   props: {
      //     response: {
      //       id: this.user.user_id,
      //       phone: this.user.userPersonalPhone,
      //     },
      //   },
      // });
    },
    showSuccessModal(result) {
      this.modal.show(
        SignInSuccessPhoneUpdate,
        { result, messages: this.messages },
        {
          width: '340px',
        }
      );
      // this.$DefModal.show({
      //   name: 'SignInSuccessPhoneUpdate',
      //   width: '340px',
      //   props: { result, messages: this.messages },
      // });
    },
  },
  mounted() {
    this.clearState();
    this.counter();
  },
  beforeUnmount() {
    clearTimeout(this.timeOut);
  },
};
</script>

<style lang="scss" scoped>
.sign-in-confirm-updating-phone {
  &__text {
    font-weight: 500;
    font-size: rem(14);
    line-height: 130%;
    margin-bottom: 8px;
  }
  &__timer {
    color: var(--color-dark-grey);
  }
  &__mistake {
    margin-bottom: 24px;
  }
  :deep(.def-link) {
    display: inline-block;
    color: var(--color-dark-grey);
    font-size: rem(14);
  }
  :deep(.def-button-primary) {
    width: 100%;
    margin-top: 24px;
  }
}
</style>
